(function () {
    if (typeof document == 'undefined') return;
    tinymce.PluginManager.add('font_size_buttons', function(editor, url) {
        editor.ui.registry.addMenuItem('fontsize_decrease', {
            text: 'Font size decrease',
            onAction: function() {
                editor.execCommand('fontsize_decrease');
            }
        });

        editor.ui.registry.addMenuItem('fontsize_increase', {
            text: 'Font size increase',
            onAction: function() {
                editor.execCommand('fontsize_increase');
            }
        });

        editor.ui.registry.addButton('fontsize_decrease', {
            tooltip: 'Font size decrease',
            icon: 'horizontal-rule',
            onAction: function() {
                editor.execCommand('fontsize_decrease');
            }
        });

        editor.ui.registry.addButton('fontsize_increase', {
            tooltip: 'Font size increase',
            icon: 'plus',
            onAction: function() {
                editor.execCommand('fontsize_increase');
            }
        });

        editor.ui.registry.addButton('fontsize_change', {
            tooltip: 'Font size change',
            icon: 'resize-handle',
            onAction: function() {
                var node = tinymce.activeEditor.selection.getNode();
                var fontSize = tinymce.activeEditor.dom.getStyle(node, 'font-size', true);
                fontSize = fontSize.split('px', 1)[0];

                editor.windowManager.open({
                    title: 'Font size',
                    body: {
                        type: 'panel',
                        items: [{
                            type: 'bar',
                            items: [{
                                    type: 'button',
                                    name: 'font_size_sub',
                                    text: '',
                                    icon: 'horizontal-rule'
                                }, {
                                    type: 'input',
                                    name: 'font_size',
                                    inputMode: 'numeric',
                                    maximized: true
                                }, {
                                    type: 'button',
                                    name: 'font_size_add',
                                    text: '',
                                    icon: 'plus'
                                }
                            ]
                        }]
                    },
                    buttons: [{
                        type: 'cancel',
                        name: 'close_button',
                        text: 'Cancel'
                    }, {
                        type: 'submit',
                        name: 'submit_button',
                        text: 'Save',
                        buttonType: 'primary'
                    }],
                    initialData: {
                        font_size: fontSize
                    },
                    onAction: function (api, btn) {
                        if (btn.name === 'font_size_sub') {
                            var font_size = parseInt(api.getData().font_size);
                            api.setData({ font_size: (font_size <= 1 ? 1 : (font_size - 1)) + '' });
                        }
                        if (btn.name === 'font_size_add') {
                            var curr = parseInt(api.getData().font_size);
                            curr++;
                            api.setData({
                                font_size: (curr + '')
                            });
                        }
                    },
                    onSubmit: function(api) {
                        var fontSize = api.getData().font_size;
                        if (fontSize.match(/^\d+$/)) {
                            tinymce.activeEditor.execCommand('fontsize', false, fontSize + 'px');
                        }
                        api.close();
                    }
                });
            }
        });

        editor.addCommand('fontsize_decrease', function() {
            var node = tinymce.activeEditor.selection.getNode();
            var fontsize = tinymce.activeEditor.dom.getStyle(node, 'font-size', true);
            fontsize = fontsize.split('px', 1);
            fontsize--;
            fontsize = fontsize + 'px';
            tinymce.activeEditor.execCommand('fontsize', false, fontsize);
        });

        editor.addCommand('fontsize_increase', function() {
            var node = tinymce.activeEditor.selection.getNode();
            var fontsize = tinymce.activeEditor.dom.getStyle(node, 'font-size', true);
            fontsize = fontsize.split('px', 1);
            fontsize++;
            fontsize = fontsize + 'px';
            tinymce.activeEditor.execCommand('fontsize', false, fontsize);
        });

        tinymce.addI18n('sk', {
            'Font size': 'Veľkosť písma',
            'Font size decrease': 'Zmenšiť písmo',
            'Font size increase': 'Zväčšiť písmo',
            'Font size change': 'Zmeniť veľkosť písma'
        });
    });
})();
